import pagesConfig from "../configs/pages.config.json";
import HttpService from "./https-service";

class AuthService {
    #storage = sessionStorage;
    #tokenKey = "__ApplicationVerification";

    /**
     * Login.
     * @param {string} userId - User id.
     * @param {string} password - Password.
     * @returns {Promise} - Promise object. (axios)
     */
    login(userId, password) {
        const addObj = {
            user_id: userId,
            password: password,
            schema_name: process.env.REACT_APP_SCHEMA_NAME,
        };
        return HttpService.send("post", "auth", "login", addObj);
    }

    /**
     * Logout.
     */
    logout() {
        this.#storage.clear();
    }

    /**
     * Get token.
     * @returns {string} - Token.
     */
    getToken() {
        let token;
        try {
            token = this.#storage.getItem(this.#tokenKey);
            if (!token) {
                token = "";
            }
        } catch (error) {
            token = "";
        }
        return token;
    }

    /**
     * Set token.
     * @param {string} token - Token.
     */
    setToken(token) {
        this.#storage.setItem(this.#tokenKey, token);
    }

    /**
     * Authenticate user whether has permission to access page.
     * @param {string} userPermission - User permission.
     * @param {string} pathName - Path name.
     * @returns {boolean} - True if user has permission to access page, otherwise false.
     */
    authPagePermission(userPermission, pathCode) {
        return pagesConfig[pathCode]["permission"].includes(userPermission);
    }
}

// eslint-disable-next-line
export default new AuthService();
